import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "KDE 4.0",
  "description": "",
  "published": "2007-01-05T00:00:00.000Z",
  "redirect_from": ["/blog/kde-40/swizec/338"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It is true that KDE 4.0 is still a fair bit away from being a reality but there has been much hype surrounding it and a lot of speculation has been put into what the end result might look like. `}<a parentName="p" {...{
        "href": "http://linuxhelp.blogspot.com/2007/01/sneek-preview-of-expected-features-in.html"
      }}>{`This`}</a>{` looks like one of the first reliable pieces of information about it, which explains the most prominent differences well.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      